import { baseApi } from "./baseApi";
import { parseInsuranceOverview } from "../parsers/insurance.parser";

/**
 * Insurance API slice
 * Injects insurance-related endpoints into the base API
 */
export const insuranceApiSlice = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Get insurance overview
         * @returns {Object} Insurance data grouped by category (Life/General)
         */
        getInsuranceOverview: builder.query({
            query: () => ({
                url: "/api/account-aggregator/insurance",
                method: "GET",
            }),
            transformResponse: (response) => parseInsuranceOverview(response),
            providesTags: ["InsurancePolicies"],
        }),
    }),
    overrideExisting: true,
});

export const {
    useGetInsuranceOverviewQuery,
    useLazyGetInsuranceOverviewQuery,
} = insuranceApiSlice;
